import Loadable from '../../../../components/loadable';
import prerenderedLoadable from '../../../../components/prerender';

const Page = Loadable(() =>
  import(
    /* webpackChunkName: "business-products-virtual-accessories" */ './index'
  )
);

export default prerenderedLoadable(Page);
